import { routeFileSelector } from '@utilz/i18n';
import { useGetPSLList } from '@views/screens/common/hooks';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';

export const PSLSelect = ({ name = 'psl', label, editMode = true, placeholder = 'Select PSL', ...rest }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  const { data: dataOptions = [], isLoading } = useGetPSLList();

  return (
    <FormSelectBox
      loading={isLoading}
      name={name}
      label={label || t('translation:getQuote.shippingTermsSearch.psl.label')}
      editMode={editMode}
      placeholder={placeholder}
      options={dataOptions}
      {...rest}
    />
  );
};
